import ActionTypePlan from "../ActionTypePlan";

export default class CargaDePlanesBuscados extends ActionTypePlan {
    ejecutar(estado, nuevoEstado) {
        nuevoEstado.flag.procesandoComando = false;
        nuevoEstado.data = this.payload;
        return nuevoEstado;
    }
}
